import {
  Navigate,
  Outlet,
  RouterProvider,
  createBrowserRouter,
} from 'react-router-dom';

import {
  findAllowedURLParams,
  useFlow,
} from '@service-initiation/shared-data-access-flow-manager';
import {
  LeftSectionContainer,
  PageContainer,
  RightSectionContainer,
} from '@service-initiation/shared-ui-page-layout';
import { TechCareAnalyticsProvider } from '@service-initiation/tech-care-data-access-analytics';
import { Route } from '@service-initiation/tech-care-data-access-routing';
import {
  CancelAppointmentPage,
  ConfirmedCancellationPage,
} from '@service-initiation/tech-care-features-cancel-appointment';
import { AppointmentOverview } from '@service-initiation/tech-care-ui-appointment-overview';

import { ErrorBoundary } from './ErrorBoundary';
import { FlowContainer } from './FlowContainer';

export const Router = ({ baseName }: { baseName: string }) => {
  const { value: flow } = useFlow();
  const urlParams = findAllowedURLParams();

  return (
    <RouterProvider
      router={createBrowserRouter(
        [
          {
            children: [
              {
                element: (
                  <PageContainer>
                    <LeftSectionContainer>
                      <CancelAppointmentPage />
                    </LeftSectionContainer>
                    <RightSectionContainer>
                      <AppointmentOverview />
                    </RightSectionContainer>
                  </PageContainer>
                ),
                errorElement: <ErrorBoundary />,
                path: Route.CancelAppointment.replace(/^\//, ''),
              },
              {
                element: <ConfirmedCancellationPage />,
                errorElement: <ErrorBoundary />,
                path: Route.ConfirmCancel.replace(/^\//, ''),
              },
              {
                children: [
                  ...Object.entries(flow).map(([path, step]) => ({
                    element: step.component,
                    path: path.replace(/^\//, ''),
                  })),
                  {
                    element: (
                      <Navigate
                        to={`${Route.Landing}?${urlParams.toString()}`}
                      />
                    ),
                    path: '*',
                  },
                ],
                element: (
                  <FlowContainer>
                    <PageContainer>
                      <LeftSectionContainer>
                        <Outlet />
                      </LeftSectionContainer>
                      <RightSectionContainer>
                        <AppointmentOverview />
                      </RightSectionContainer>
                    </PageContainer>
                  </FlowContainer>
                ),
                errorElement: <ErrorBoundary />,
                path: '*',
              },
            ],
            element: (
              <TechCareAnalyticsProvider>
                <Outlet />
              </TechCareAnalyticsProvider>
            ),
            path: '*',
          },
          {
            element: (
              <Navigate to={`${Route.Landing}?${urlParams.toString()}`} />
            ),
            path: '*',
          },
        ],
        {
          basename: baseName,
        }
      )}
    />
  );
};
